import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOrganizationmin = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9 5.25h7.5v10.5h-15V2.25H9v3Zm-6 9h1.5v-1.5H3v1.5Zm1.5-3H3v-1.5h1.5v1.5Zm-1.5-3h1.5v-1.5H3v1.5Zm1.5-3H3v-1.5h1.5v1.5Zm1.5 9h1.5v-1.5H6v1.5Zm1.5-3H6v-1.5h1.5v1.5Zm-1.5-3h1.5v-1.5H6v1.5Zm1.5-3H6v-1.5h1.5v1.5Zm1.5 9h6v-7.5H9v1.5h1.5v1.5H9v1.5h1.5v1.5H9v1.5Zm4.5-6H12v1.5h1.5v-1.5Zm-1.5 3h1.5v1.5H12v-1.5Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgOrganizationmin);
export { ForwardRef as ReactComponent };
